import React from "react";
import PassportSection from "@/components/PassportSection";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function Passport() {
  usePageMeta(
    "CHILLWOAH Passport — Claim Your Number",
    "A collectible, numbered CHILLWOAH Passport membership. The first 1,000 numbers are free and permanent — early drops, exclusive songs, members-only experiences."
  );

  return (
    <div data-testid="passport-page">
      <header className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 sm:pt-24 pb-4">
        <p className="font-mono text-xs sm:text-sm font-semibold tracking-[0.3em] uppercase text-[#F26522]">Membership</p>
        <h1 className="mt-4 font-display font-extrabold uppercase text-4xl sm:text-6xl lg:text-7xl text-white tracking-tight leading-[0.95]">
          Passport
        </h1>
        <div className="rule-lux mt-8" aria-hidden="true" />
      </header>
      <PassportSection />
    </div>
  );
}
